export default {
  navTheme: 'dark', // theme for nav menu
  primaryColor: '#2F54EB', // primary color of ant design
  layout: 'sidemenu', // nav menu position: `sidemenu` or `topmenu`
  contentWidth: 'Fluid', // layout of content: `Fluid` or `Fixed`, only works when layout is top menu
  fixedHeader: false, // sticky header
  fixSiderbar: false, // sticky siderbar
  mutiTab: true, // 开启TAB
  tabSize: 'small', // TAB大小，提供 large default 和 small 三种大小
  menu: {
    locale: true
  },
  title: '桩桩护航',
  production: process.env.NODE_ENV === 'production' && process.env.VUE_APP_PREVIEN !== 'true',
  development: process.env.NODE_ENV == 'development',
}



// WEBPACK FOOTER //
// ./src/config/defaultSettings.js